import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IWallet } from '../../my-credits/interfaces';
import { ApiService } from 'src/app/core/http/api.service';
import { MessageService } from 'primeng/api';
import { ApiCore } from 'src/app/config/api';
import { DeviceDetectorService } from 'src/app/shared/services/device-detector.service';

@Component({
  selector: 'notificationes-bonos',
  templateUrl: './bonos.component.html',
  styleUrls: ['./bonos.component.css'],
})
export class BonosComponent implements OnInit {
  public loadingBonos = true;
  public bonos: {
    creditsAmount: number;
    createdAt: string;
    id: string;
  }[] = [];

  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter();
  @Input() public show: boolean = false;
  @Input() public newNoti: boolean = false;
  @Input() public isDisabled: boolean = false;

  constructor(
    private readonly api: ApiService,
    private readonly elementRef: ElementRef,
    private readonly deviceDetector: DeviceDetectorService
  ) {}

  ngOnInit(): void {}

  // private getBonuses(){
  //   this.api.list(ApiCore.OPERATOR + '/last-bonuses').subscribe({
  //     next: (res) => {
  //       console.log({Bonuses: res});
  //       this.bonos = res.data;
  //       this.loadingBonos = false;
  //     },
  //     error: (err) => {
  //       console.error({err});
  //     },
  //   });
  // }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.onClose.emit();
    }
  }

  toggleBonos() {
    this.onToggle.emit();
  }
  closeModal() {
    this.onClose.emit();
  }
}
